// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"85":"e5e17a1bfa7df479","918":"126b89cdae0ec7d1","919":"7e5eabaa222e16ac"}[chunkId] + ".js";
};